module.exports = __webpack_public_path__ + "img/pink-call-linear-20x20.9ea46d9e.svg";